import { render } from "./PrivacyPolitics.vue?vue&type=template&id=2da0416a&scoped=true"
const script = {}

import "./PrivacyPolitics.vue?vue&type=style&index=0&id=2da0416a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da0416a"]])

export default __exports__